import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import { applyTheme, readTheme } from './lib/theme.js';
import './index.css';

// Before the first paint, so a dark-theme reader never sees a white flash.
applyTheme(readTheme());

/**
 * Entry point. `queryClient` is created here rather than at module scope so a test
 * can build its own without inheriting this one's cache.
 */

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // A security console is read repeatedly; a minute of staleness is plenty and
      // keeps the API from being polled on every navigation.
      staleTime: 30_000,
      retry: 1,
    },
  },
});

const container = document.getElementById('root');
if (container === null) throw new Error('index.html is missing its root element');

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);
